// extracted by mini-css-extract-plugin
export var fadeIn = "_gb-1";
export var modalContent = "_gb-3";
export var overlay = "_gb-0";
export var popoverContent = "_gb-2";
export var results = "_gb-5";
export var searchInputWrapper = "_gb-4";